import { appStore } from "../../stores";

export function copyToClipboard(value: string) {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();
    appStore.setSnackbar("Copied to clipboard");
}
